import React from 'react';
import { StatusDot } from '@/components/shared/StatusDot';
import { ExecutionTape } from '@/components/tape/ExecutionTape';
import './RightPanel.css';

export const RightPanel: React.FC = () => {
  return (
    <aside className="right-panel">
      <div className="right-panel__header">
        <StatusDot color="green" />
        <span>Live Execution Tape</span>
      </div>
      <div className="right-panel__body">
        <ExecutionTape />
      </div>
    </aside>
  );
};
